import NoMatchOrRedirect, { loader as noMatchOrRedirectLoader } from '../../no-match/NoMatchOrRedirect';
import { fetchPublicSubprojectsById } from './subproject-actions';
import { getSubproject } from '../subproject-selectors';
import { isValidProjectId } from '../project-model';
import { cachedRedirect } from '../../utils/cache-utils';

const SubprojectRedirect = () => {
    return <NoMatchOrRedirect />;
};

export const loader = async (props) => {
    const { dispatch, getState, params } = props;
    const subprojectIdFromUrl = params.slug;
    if (isValidProjectId(subprojectIdFromUrl)) {
        await dispatch(fetchPublicSubprojectsById(subprojectIdFromUrl));
    }

    const state = getState();

    const subprojectId = parseInt(subprojectIdFromUrl, 10);
    const subproject = getSubproject(state, subprojectId);

    if (subproject?.id) {
        return cachedRedirect(`/project/${subproject.project_id}?subproject=${subprojectId}`);
    } else {
        return noMatchOrRedirectLoader(props);
    }
};

export default SubprojectRedirect;
